import { render, staticRenderFns } from "./ZedlockerBalance.vue?vue&type=template&id=ff1a2878&scoped=true"
import script from "./ZedlockerBalance.vue?vue&type=script&lang=js"
export * from "./ZedlockerBalance.vue?vue&type=script&lang=js"
import style0 from "./ZedlockerBalance.vue?vue&type=style&index=0&id=ff1a2878&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff1a2878",
  null
  
)

export default component.exports